import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  getOrderDetailsAPI,
  getOrderListAPI,
} from "../../service/cart.service";
import SpinnerComponent from "../../components/atoms/spinner/spinner.component";
import {
  FiArrowLeft,
  FiCalendar,
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiPackage,
  FiTruck,
} from "react-icons/fi";
import "./order-details.component.css";
import FooterComponent from "../Footer/footer.component";
import HeaderComponent from "../Header/header.component";

const OrderDetailsComponent = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const orderIdFromState = location.state?.id;

  const onLoad = async () => {
    try {
      setLoading(true);
      const response = await getOrderDetailsAPI(orderIdFromState || orderId);
      console.log(response);
      if (response.status) {
        console.log(response.data);
        setOrder(response.data);
      } else {
        setError(response.message || "Failed to load order details");
      }
    } catch (err) {
      setError("An error occurred while fetching order details");
      console.error("Error fetching order details:", err);
    } finally {
      setLoading(false);
    }
  };
  console.log({ order });

  useEffect(() => {
    onLoad();
  }, []);
  console.log({ order });

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 80 }}>
        <SpinnerComponent />
      </div>
    );
  }

  if (error) {
    return (
      <div className="ds-container" style={{ paddingBlock: 48 }}>
        <div className="ds-state">
          <h3>{error}</h3>
          <button className="ds-btn ds-btn-secondary" onClick={() => navigate(-1)}>
            <FiArrowLeft /> Back to Orders
          </button>
        </div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="ds-container" style={{ paddingBlock: 48 }}>
        <div className="ds-state">
          <span className="ico"><FiPackage size={28} /></span>
          <h3>Order Not Found</h3>
          <p>We couldn't find the order you're looking for.</p>
          <button className="ds-btn ds-btn-secondary" onClick={() => navigate(-1)}>
            <FiArrowLeft /> Back to Orders
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ds-container">
      {order.map((item) => (
        <div key={item.id} style={{ paddingBottom: 40 }}>
          <div className="ds-head-row" style={{ alignItems: "center", marginBlock: "16px 24px" }}>
            <div>
              <p className="ds-eyebrow">Order</p>
              <h1 className="ds-mono" style={{ fontSize: 26 }}>#{item.order_id}</h1>
            </div>
            <button className="ds-btn ds-btn-ghost" onClick={() => navigate(-1)}>
              <FiArrowLeft /> Back to Orders
            </button>
          </div>

          <div className="ds-grid-cart">
            <div className="ds-stack">
              {/* Items */}
              <div className="ds-table-wrap">
                <table className="ds-table">
                  <thead>
                    <tr>
                      <th>Part</th>
                      <th>Description</th>
                      <th className="num">Qty</th>
                      <th className="num">Price</th>
                      <th className="num">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.order.map((product, index) => (
                      <tr key={index}>
                        <td>
                          <div className="ds-row" style={{ flexWrap: "nowrap" }}>
                            <span className="ds-thumb" style={{ width: 44, height: 44, aspectRatio: "auto", borderRadius: 4, flex: "0 0 auto" }}>
                              {product.product_details.image ? <img src={product.product_details.image} alt="" /> : null}
                            </span>
                            <span className="mpn">{product.product_details.part_number}</span>
                          </div>
                        </td>
                        <td>{product.product_details.description}</td>
                        <td className="num">{product.qty}</td>
                        <td className="price">₹{product.selected_price}</td>
                        <td className="price">₹{product.total_amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Addresses */}
              <div className="ds-grid-2">
                <div className="ds-panel ds-panel-p">
                  <p className="ds-eyebrow">Shipping address</p>
                  <address style={{ fontStyle: "normal" }} dangerouslySetInnerHTML={{ __html: item.shipping_address }} />
                </div>
                <div className="ds-panel ds-panel-p">
                  <p className="ds-eyebrow">Billing address</p>
                  <address style={{ fontStyle: "normal" }} dangerouslySetInnerHTML={{ __html: item.billing_address }} />
                </div>
              </div>
            </div>

            {/* Summary */}
            <aside className="ds-summary">
              <h3>Order summary</h3>
              <div className="ds-summary-row"><span>Order placed</span><span className="val" style={{ fontFamily: "var(--font-ui)" }}>{item.date}</span></div>
              <div className="ds-summary-row"><span>Status</span><span className="ds-badge ds-badge-info"><span className="dot"></span>{item.status_name}</span></div>
              <div className="ds-summary-row"><span>Payment</span><span className="ds-badge ds-badge-success">{item.payment_status}</span></div>
              <div className="ds-summary-row"><span>Subtotal</span><span className="val">₹{item.total_amount?.toLocaleString("en-IN")}</span></div>
              <div className="ds-summary-row"><span>Tax (GST)</span><span className="val">₹{item.tax_amount?.toLocaleString("en-IN")}</span></div>
              <div className="ds-summary-row total"><span>Total</span><span className="val">₹{item.total_amount?.toLocaleString("en-IN")}</span></div>
            </aside>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderDetailsComponent;
